export default __webpack_public_path__ + "static/media/leftBg.b25e4e1d.png";